import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { loading,Popconfirm,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import camera from '../../assets/images/icon/camera.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}


function disabledDate(current) {
  // Can not select days before today and today
   return current && current > moment().endOf('day');
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const dateFormat = 'YYYY-MM-DD';
const storedFiles=[];
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			cau_deposit: '',
			division: '',
			house: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			loading: false,
			value: '',
			values: [0],
			first_name: '',
			last_name: '',
			birthday: '',
			blood_group: '',
			gender: '',
			joining_date: '',
			unique_id: '',
			address: '',
			allergies: '',
			notes: '',
			parent_first_name: '',
			parent_last_name: '',
			parent_mobile: '',
			parent_relation: '',
			parent_email: '',
			program_id : '',
			program_list : [],
			student_list : [],
			parent_relation : [],
			delete_parent : [],
			previewImage: '',
			previewTitle: '',
			previewVisible: false,
			file_list: [],
			file_list_pdf: [],
			file_list_audio: [],
			division_list: [],
			image: [],	
			file1:null,
			file2:null,
			file3:null,
			file4:null,
			file5:null,
			old_file1: '',
			old_file2: '',
			old_file3: '',
			old_file4: '',
			old_file5: '',
			transfer_certificate_details: '',
			health_certificate_details: '',
			bonafied_certificate_details: '',
			nirgam_document_details:'',
			id_card_details: '',
			day_care: 0,
			actual_fee: 0,
			transport: 0,
			total_fee: 0,			
			admission_fee:0,
			admission_form:0,
			confirmation_fee:0,
			tuition_fee_1:0,
			tuition_fee_1_date:'',
			tuition_fee_2:0,
			tuition_fee_2_date:'',
			tuition_fee_3:0,
			tuition_fee_3_date:'',
			starter_kit:0,
			uniform:0,
			activity_fee:0,
			total_fee:0,
			deposit:0,
			transport_term_1:0,
			transport_term_1_date:'',
			transport_term_2:0,
			transport_term_2_date:'',
			january:0,
			january_due_date:'',
			february:0,
			february_due_date:'',
			march:0,
			march_due_date:'',
			april:0,
			april_due_date:'',
			may:0,
			may_due_date:'',
			june:0,
			june_due_date:'',
			july:0,
			july_due_date:'',
			august:0,
			august_due_date:'',
			september:0,
			september_due_date:'',
			october:0,
			october_due_date:'',
			november:0,
			november_due_date:'',
			december:0,
			december_due_date:'',
			file1:null,
			file2:null,
			file3:null,
			file4:null,
			file5:null,
			file6:null,
			file7:null,
			file8:null,
			file9:null,
			file10:null,
			file11:null,
			file12:null,
			file13:null,
			file15:null,
			old_file1: '',
			old_file2: '',
			old_file3: '',
			old_file4: '',
			old_file5: '',
			old_file6: '',
			old_file7: '',
			old_file8: '',
			old_file9: '',
			old_file10: '',
			old_file11: '',
			old_file12: '',
			old_file13: '',
			old_file14: '',
			birth_cert_details: '',
			transfer_certificate_details: '',
			last_exam_marksheet_details: '',
			mother_photo_detalis: '',
			father_photo_detalis: '',
			cast_certificate_details: '',
			health_certificate_details: '',
			vaccination_card_details: '',
			father_aadhar_details: '',
			mother_aadhar_details: '',
			student_aadhar_details: '',
			address_doc_details: '',
			death_certificate_details: '',
			admission_form_details: '',
			permission: [],
			type: '',
			user_type: '',
			place_search: [],
			transport_details: [],
			academic_year_: [],
			state_list: [],
			state: '',
			city_list: [],
			city: '',
			address: '',
			emergency: 'Yes',
			language: '',
			pincode: '',
			language: '',
			transport_way:'1',
			daycare_hour:'2',
			note:'',
			transport_term_3:'',
			transport_term_3_date:'',
			transport_term_4:'',
			transport_term_4_date:'',
			transport_note:'',
			day_care_note:'',
			summer_camp:'',
			summer_camp_date:'',
			daycare_total_fee:0,
			daycare_amount:0,
			initial_fee:0,
			admission_total: 0,
			other_total: 0,
			tuition_total: 0,
			is_promote: 0,
			admission_fee_remark: '',
			confirmation_fee_remark: '',
			tuition_fee_1_remark: '',
			tuition_fee_2_remark: '',
			tuition_fee_3_remark: '',
			starter_kit_remark: '',
			request_reason: '',
			new_amount: '',
			fees_modal: false,
			modal_title: '',
			loading: false,
		}
		this.change_year = this.change_year.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.onChangebirthday = this.onChangebirthday.bind(this);	
		this.onChangejoin = this.onChangejoin.bind(this);	
		this.change_blood_group = this.change_blood_group.bind(this);	
		this.change_gender = this.change_gender.bind(this);	
		
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.goBack = this.goBack.bind(this);	
		this.change_relation = this.change_relation.bind(this);	
		this.change_status = this.change_status.bind(this);	
		
		this.change_type = this.change_type.bind(this);	
		this.handletran = this.handletran.bind(this);	
		this.handlesms = this.handlesms.bind(this);	
		
		this.getTotal = this.getTotal.bind(this);	
		this.change_program_id = this.change_program_id.bind(this);	
		
		this.change_state = this.change_state.bind(this);	
		this.change_city = this.change_city.bind(this);	
		this.change_emergency = this.change_emergency.bind(this);	
		this.change_language = this.change_language.bind(this);	
		
		this.tutionfee1Change = this.tutionfee1Change.bind(this);	
		this.tutionfee2Change = this.tutionfee2Change.bind(this);	
		this.tutionfee3Change = this.tutionfee3Change.bind(this);	
		this.tutionfee4Change = this.tutionfee4Change.bind(this);	
		this.transport1Change = this.transport1Change.bind(this);	
		this.transport2Change = this.transport2Change.bind(this);	
		
		this.januaryDateChange = this.januaryDateChange.bind(this);	
		this.febDateChange = this.febDateChange.bind(this);	
		this.marDateChange = this.marDateChange.bind(this);	
		this.aprilDateChange = this.aprilDateChange.bind(this);	
		this.mayDateChange = this.mayDateChange.bind(this);	
		this.juneDateChange = this.juneDateChange.bind(this);	
		this.julyDateChange = this.julyDateChange.bind(this);	
		this.augDateChange = this.augDateChange.bind(this);	
		this.sepDateChange = this.sepDateChange.bind(this);	
		this.octDateChange = this.octDateChange.bind(this);	
		this.novDateChange = this.novDateChange.bind(this);	
		this.decDateChange = this.decDateChange.bind(this);	
		
		this.change_division = this.change_division.bind(this);	
		this.change_house = this.change_house.bind(this);	
		
		this.change_transport_way = this.change_transport_way.bind(this);
		this.summercampChange = this.summercampChange.bind(this);
		this.change_daycare_hour = this.change_daycare_hour.bind(this);
		this.transport3Change = this.transport3Change.bind(this);	
		this.transport4Change = this.transport4Change.bind(this);	
	}
	
	summercampChange(date, dateString) {
	  this.setState({ summer_camp_date: dateString });
	}
	
	transport3Change(date, dateString) {
	  this.setState({ transport_term_3_date: dateString });
	}
	
	transport4Change(date, dateString) {
	  this.setState({ transport_term_4_date: dateString });
	}
	
	change_transport_way(event){
         this.setState({transport_way: event});
     }
	
	change_daycare_hour(event){
         this.setState({daycare_hour: event});
		var app = {user_id : this.state.user_id,hours:event,school_id:this.state.school_id}
		getData('erp/get_daycare_fees_details',app).then((result) => {
			let responseJson = result;
			if(responseJson){
				if(result['status'] == 200){						
						this.setState({daycare_amount: result['data']});
			   }else{
						this.setState({daycare_amount: 0});
			   }
			}
		});
     }

	componentWillMount() {
		if(document.querySelector(".loader-wrapper")){
			document.querySelector(".loader-wrapper").style = "display: none";
		}
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		var type = storedArray['data'][0]['type'];
		var app = {user_id : storedArray['data'][0]['user_id']}
		getData('erp/check_user_permission',app).then((result) => {
			let responseJson = result;
			if(result['status'] == 200){
				setTimeout(() => {
						this.setState({
							permission: result['permission'],
						});
					}, 500);
				
			}
			
		});	
		this.setState({ user_id : storedArray['data'][0]['user_id'],id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'],user_type : type});
		this.checkData();
		}
	}
	
	 change_division(event){
         this.setState({division: event});
     }
	
	change_house(event){
         this.setState({house: event});
     }
	 
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 school_id : storedArray['data'][0]['school_id'], 
			 user_id : storedArray['data'][0]['user_id'], 
			 id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var id = this.props.match.params.id;
			var app = {user_id : user_id,id:id,school_id:school_id,type:type}
			getData('erp/new_program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
						});
					}else{
						this.setState({
							program_list: [],
						});
					}
				}
			});	
			getData('erp/get_transport_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							transport_details: result['data'],
						});
					}else{
						this.setState({
							transport_details: [],
						});
					}
				}
			});
			getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
						});
					}else{
						this.setState({
							academic_year_: [],
						});
					}
				}
			});
			getData('common/get_state',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							state_list: result['data'],
						});
					}else{
						this.setState({
							state_list: [],
						});
					}
				}
			});
			getData('erp/get_daycare_fees_by_school',app).then((result) => {
			let responseJson = result;
			if(result['status'] == 200 && result['data'].length > 0){						
					this.setState({
						daycare_fees_list: result['data'],
						daycare_amount: result['data']['0']['amount'],
					});
			}else{
					this.setState({
						daycare_fees_list: [],
					});
			}
			});			
			getData('erp/student_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							student_list: result['data'],
							is_promote: result['data'][0]['is_promote'],
							first_name: result['data'][0]['first_name'],
							last_name: result['data'][0]['last_name'],
							birthday: result['data'][0]['birthday'],
							blood_group: result['data'][0]['blood_group'],
							gender: result['data'][0]['gender'],
							joining_date: result['data'][0]['joining_date'],
							unique_id: result['data'][0]['unique_id'],
							location: result['data'][0]['location'],
							allergies: result['data'][0]['allergies'],
							notes: result['data'][0]['notes'],
							program_id: result['data'][0]['program_id'],
							is_active: result['data'][0]['is_active'],
							status: result['data'][0]['status'],
							image: result['data'][0]['image'],	
							transport: result['data'][0]['is_transport'],	
							day_care: result['data'][0]['is_day_care'],	
							type: result['data'][0]['type'],	
							longitude: result['data'][0]['longitude'],	
							latitude: result['data'][0]['latitude'],	
							parents: result['data'][0]['parents'],	
							program_name: result['data'][0]['program_name'],	
							division: result['data'][0]['division'],	
							house: result['data'][0]['house'],	
							address: result['data'][0]['address'],	
							state: result['data'][0]['state'],	
							city: result['data'][0]['city'],	
							pincode: result['data'][0]['pincode'],	
							language: result['data'][0]['language'],	
							emergency: result['data'][0]['emergency'],	
							note: result['data'][0]['note'],	
							transport_way: result['data'][0]['transport_way'],	
							initial_fee: result['data'][0]['initial_fee'],	

							actual_fee:  result['data'][0]['actual_fee'],
							admission_fee:  result['data'][0]['admission_fee'],
							admission_form:  result['data'][0]['admission_form'],
							confirmation_fee:  result['data'][0]['confirmation_fee'],
							tuition_fee_1:  result['data'][0]['tuition_fee_1'],
							tuition_fee_1_date:  result['data'][0]['tuition_fee_1_date'],
							tuition_fee_2:  result['data'][0]['tuition_fee_2'],
							tuition_fee_2_date:  result['data'][0]['tuition_fee_2_date'],
							tuition_fee_3:  result['data'][0]['tuition_fee_3'],
							tuition_fee_3_date:  result['data'][0]['tuition_fee_3_date'],
							tuition_fee_4_date:  result['data'][0]['tuition_fee_4_date'],
							starter_kit:  result['data'][0]['starter_kit'],
							uniform:  result['data'][0]['uniform'],
							activity_fee:  result['data'][0]['activity_fee'],
							total_fee:  result['data'][0]['total_fee'],
							transport_term_1:  result['data'][0]['transport_term_1'],
							transport_term_1_date:  result['data'][0]['transport_term_1_date'],
							transport_term_2:  result['data'][0]['transport_term_2'],
							transport_term_2_date:  result['data'][0]['transport_term_2_date'],
							transport_term_3:  result['data'][0]['transport_term_3'],
							transport_term_3_date:  result['data'][0]['transport_term_3_date'],
							transport_term_4:  result['data'][0]['transport_term_4'],
							transport_term_4_date:  result['data'][0]['transport_term_4_date'],
							transport_note:  result['data'][0]['transport_note'],
							daycare_hour:  result['data'][0]['daycare_hour'],
							day_care_note:  result['data'][0]['day_care_note'],
							cau_deposit:  result['data'][0]['cau_deposit'],
							summer_camp:  result['data'][0]['summer_camp'],
							summer_camp_date:  result['data'][0]['summer_camp_date'],
							deposit:  result['data'][0]['deposit'],
							january:  result['data'][0]['january'],
							january_due_date:  result['data'][0]['january_due_date'],
							february:  result['data'][0]['february'],
							february_due_date:  result['data'][0]['february_due_date'],
							march:  result['data'][0]['march'],
							march_due_date:  result['data'][0]['march_due_date'],
							april:  result['data'][0]['april'],
							april_due_date:  result['data'][0]['april_due_date'],
							may:  result['data'][0]['may'],
							may_due_date:  result['data'][0]['may_due_date'],
							june:  result['data'][0]['june'],
							june_due_date:  result['data'][0]['june_due_date'],
							july:  result['data'][0]['july'],
							july_due_date:  result['data'][0]['july_due_date'],
							august:  result['data'][0]['august'],
							august_due_date:  result['data'][0]['august_due_date'],
							september:  result['data'][0]['september'],
							september_due_date:  result['data'][0]['september_due_date'],
							october:  result['data'][0]['october'],
							october_due_date:  result['data'][0]['october_due_date'],
							november:  result['data'][0]['november'],
							november_due_date:  result['data'][0]['november_due_date'],
							december:  result['data'][0]['december'],
							december_due_date:  result['data'][0]['december_due_date'],
							
							old_file1:  result['data'][0]['file1'],
							old_file2:  result['data'][0]['file2'],
							old_file3:  result['data'][0]['file3'],
							old_file4:  result['data'][0]['file4'],
							old_file5:  result['data'][0]['file5'],
							old_file6:  result['data'][0]['file6'],
							old_file7:  result['data'][0]['file7'],
							old_file8:  result['data'][0]['file8'],
							old_file9:  result['data'][0]['file9'],
							old_file10:  result['data'][0]['file10'],
							old_file11:  result['data'][0]['file11'],
							old_file12:  result['data'][0]['file12'],
							old_file13:  result['data'][0]['file13'],
							old_file14:  result['data'][0]['file14'],
							program_intrested: result['data'][0]['program_id'],
							program_id: result['data'][0]['program_id'],
							birth_cert_details:  result['data'][0]['birth_cert_details'],
							transfer_certificate_details:  result['data'][0]['transfer_certificate_details'],
							last_exam_marksheet_details:  result['data'][0]['last_exam_marksheet_details'],
							mother_photo_detalis:  result['data'][0]['mother_photo_detalis'],
							father_photo_detalis:  result['data'][0]['father_photo_detalis'],										cast_certificate_details:  result['data'][0]['cast_certificate_details'],							health_certificate_details:  result['data'][0]['health_certificate_details'],										
							vaccination_card_details:  result['data'][0]['vaccination_card_details'],										father_aadhar_details:  result['data'][0]['father_aadhar_details'],							mother_aadhar_details:  result['data'][0]['mother_aadhar_details'],	
							student_aadhar_details:  result['data'][0]['student_aadhar_details'],	
							address_doc_details:  result['data'][0]['address_doc_details'],	
							death_certificate_details:  result['data'][0]['death_certificate_details'],	
							admission_form_details:  result['data'][0]['admission_form_details'],	
							academic_year:  result['data'][0]['academic_year'],	
							daycare_total_fee:  result['data'][0]['daycare_total_fee'],	
							admission_req:  result['data'][0]['admission_req'],	
							tuition_1_req:  result['data'][0]['tuition_1_req'],	
							tuition_2_req:  result['data'][0]['tuition_2_req'],	
							tuition_3_req:  result['data'][0]['tuition_3_req'],	
							student_type:  result['data'][0]['student_type'],	
							curriculum:  result['data'][0]['curriculum'],	
							term:  result['data'][0]['term'],	
							term_type:  result['data'][0]['term_type'],	
							
						});
						
						setTimeout(() => {
							this.change_state(result['data'][0]['state']);
						}, 500);
						
						setTimeout(() => {
							this.change_program_id(result['data'][0]['program_id']);
						}, 500);
						
						const lenght = result['data'][0]['parents'].length;
						for (var i = 0; i < lenght; i++) {
							if(document.getElementById('parent_relation_'+i)){
								let element = document.getElementById('parent_relation_'+i);
								element.value = result['data'][0]['parents'][i]['relation'];
							}
						}		
						
						if(result['data'][0]['is_day_care'] == 1){
							if(document.getElementById("is_day_care")){
								document.getElementById("is_day_care").checked = true;
							}
						}
						if(result['data'][0]['is_transport'] == 1){
							if(document.getElementById("is_transport")){
								document.getElementById("is_transport").checked = true;
							}
						}
						
						
						
						this.setState({
							values:  result['data'][0]['parents'],
						});
						
						const count = result['data'][0]['parents']
						const lenght_ = count.length;
						
						
								
						
					}else{
						this.setState({
							student_list: [],
						});
					}
				}
			});				
	}
	}
	
	change_state(event){     
		this.setState({state: event,city_list:[],city:''});
		 var app = {user_id : this.state.user_id,state_id:event,school_id:this.state.school_id}
		 getData('common/get_city_by_state',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						city_list: result['data'],
					});
				}else{
					this.setState({
						city_list: [],
					});
				}
			}
		});	
		
     }
	 
	 change_city(event){     
		this.setState({city: event});
     }
	 
	 change_emergency(event){     
		this.setState({emergency: event});
     }
	 
	 change_language(event){     
		this.setState({language: event});
     }
  
  openQuantity(e){
		this.setState({ program_id: e });
	}  
	
	
	onChangebirthday(date, dateString) {
	  this.setState({ birthday: dateString });
	}
	
	onChangejoin(date, dateString) {
	  this.setState({ joining_date: dateString });
	}
	
	change_gender(event){
         this.setState({gender: event});
     }
	 
	change_blood_group(event){
         this.setState({blood_group: event});
     }
	
	change_relation(event){
		this.setState({
		  parent_relation: [...this.state.parent_relation, event]
		})
     }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		setTimeout(() => {
			this.getTotal();
			this.getDaycareTotal();
		}, 500);
	  };
	  
	  
	getTotal = e => {
		if(this.state.initial_fee !='' || this.state.initial_fee !=null){ var initial_fee = this.state.initial_fee}else{ var initial_fee = 0}
		if(this.state.admission_fee !='' || this.state.admission_fee !=null){ var admission_fee = this.state.admission_fee}else{ var admission_fee = 0}
		if(this.state.cau_deposit !='' || this.state.cau_deposit !=null){ var cau_deposit = this.state.cau_deposit}else{ var cau_deposit = 0}
		if(this.state.admission_form !='' || this.state.admission_form !=null){ var admission_form = this.state.admission_form}else{ var admission_form = 0}
		if(this.state.confirmation_fee !='' || this.state.confirmation_fee !=null){ var confirmation_fee = this.state.confirmation_fee}else{ var confirmation_fee = 0}
		if(this.state.tuition_fee_1 !='' || this.state.tuition_fee_1 !=null){ var tuition_fee_1 = this.state.tuition_fee_1}else{ var tuition_fee_1 = 0}
		if(this.state.tuition_fee_2 !='' || this.state.tuition_fee_2 !=null){ var tuition_fee_2 = this.state.tuition_fee_2}else{ var tuition_fee_2 = 0}
		if(this.state.tuition_fee_3 !='' || this.state.tuition_fee_3 !=null){ var tuition_fee_3 = this.state.tuition_fee_3}else{ var tuition_fee_3 = 0}
		if(this.state.starter_kit !='' || this.state.starter_kit !=null){ var starter_kit = this.state.starter_kit}else{ var starter_kit = 0}
		if(this.state.uniform !='' || this.state.uniform !=null){ var uniform = this.state.uniform}else{ var uniform = 0}
		if(this.state.activity_fee !='' || this.state.activity_fee !=null){ var activity_fee = this.state.activity_fee}else{ var activity_fee = 0}
		
		var total = parseInt(initial_fee)+parseInt(admission_fee)+parseInt(cau_deposit)+parseInt(admission_form)+parseInt(confirmation_fee)+parseInt(tuition_fee_1)+parseInt(tuition_fee_2)+parseInt(tuition_fee_3)+parseInt(starter_kit)+parseInt(uniform)+parseInt(activity_fee);
		this.setState({ total_fee: total });
	 };
	 
	getDaycareTotal = e => {
		if(this.state.deposit !='' || this.state.deposit !=null){ var deposit = this.state.deposit}else{ var deposit = 0}
		if(this.state.january !='' || this.state.january !=null){ var january = this.state.january}else{ var january = 0}
		if(this.state.february !='' || this.state.february !=null){ var february = this.state.february}else{ var february = 0}
		if(this.state.march !='' || this.state.march !=null){ var march = this.state.march}else{ var march = 0}
		if(this.state.april !='' || this.state.april !=null){ var april = this.state.april}else{ var april = 0}
		if(this.state.may !='' || this.state.may !=null){ var may = this.state.may}else{ var may = 0}
		if(this.state.june !='' || this.state.june !=null){ var june = this.state.june}else{ var june = 0}
		if(this.state.july !='' || this.state.july !=null){ var july = this.state.july}else{ var july = 0}
		if(this.state.august !='' || this.state.august !=null){ var august = this.state.august}else{ var august = 0}
		if(this.state.september !='' || this.state.september !=null){ var september = this.state.september}else{ var september = 0}
		if(this.state.october !='' || this.state.october !=null){ var october = this.state.october}else{ var october = 0}
		if(this.state.november !='' || this.state.november !=null){ var november = this.state.november}else{ var november = 0}
		if(this.state.december !='' || this.state.december !=null){ var december = this.state.december}else{ var december = 0}
		
		var total = parseInt(deposit)+parseInt(january)+parseInt(february)+parseInt(march)+parseInt(april)+parseInt(may)+parseInt(june)+parseInt(july)+parseInt(august)+parseInt(september)+parseInt(october)+parseInt(november)+parseInt(december);
		this.setState({ daycare_total_fee: total });
	};
	
	file_preview1 = (e) => {
		$('#file_preview1').html('1 file selected');
		this.setState({ file1: e.target.files[0]});
    }
	
	file_preview2 = (e) => {
		$('#file_preview2').html('1 file selected');
		this.setState({ file2: e.target.files[0]});
    }
	
	file_preview3 = (e) => {
		$('#file_preview3').html('1 file selected');
		this.setState({ file3: e.target.files[0]});
    }
	
	file_preview4 = (e) => {
		$('#file_preview4').html('1 file selected');
		this.setState({ file4: e.target.files[0]});
    } 
	
   file_preview5 = (e) => {
		$('#file_preview5').html('1 file selected');
		this.setState({ file5: e.target.files[0]});
    } 
	file_preview6 = (e) => {
		$('#file_preview6').html('1 file selected');
		this.setState({ file6: e.target.files[0]});
    } 
	
    file_preview7 = (e) => {
		$('#file_preview7').html('1 file selected');
		this.setState({ file7: e.target.files[0]});
    }
	
    file_preview8 = (e) => {
		$('#file_preview8').html('1 file selected');
		this.setState({ file8: e.target.files[0]});
    }
    file_preview9 = (e) => {
		$('#file_preview9').html('1 file selected');
		this.setState({ file9: e.target.files[0]});
    }
    file_preview10 = (e) => {
		$('#file_preview10').html('1 file selected');
		this.setState({ file10: e.target.files[0]});
    }
    file_preview11 = (e) => {
		$('#file_preview11').html('1 file selected');
		this.setState({ file11: e.target.files[0]});
    }
    file_preview12 = (e) => {
		$('#file_preview12').html('1 file selected');
		this.setState({ file12: e.target.files[0]});
    }
    file_preview13 = (e) => {
		$('#file_preview13').html('1 file selected');
		this.setState({ file13: e.target.files[0]});
    }
	
    file_preview14 = (e) => {
		$('#file_preview14').html('1 file selected');
		this.setState({ file14: e.target.files[0]});
    }
	
	  handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		var app = {
					id: this.props.match.params.id,
					school_id: this.state.school_id,
					user_id: this.state.user_id,
					is_active : this.state.is_active,
					is_transport: this.state.transport,
					is_day_care: this.state.day_care,
					admission_fee: this.state.admission_fee,
					admission_form: this.state.admission_form,
					cau_deposit: this.state.cau_deposit,
					confirmation_fee: this.state.confirmation_fee,
					tuition_fee_1: this.state.tuition_fee_1,
					tuition_fee_1_date: this.state.tuition_fee_1_date,
					tuition_fee_2: this.state.tuition_fee_2,
					tuition_fee_2_date: this.state.tuition_fee_2_date,
					tuition_fee_3: this.state.tuition_fee_3,
					tuition_fee_3_date: this.state.tuition_fee_3_date,
					tuition_fee_4_date: this.state.tuition_fee_4_date,
					starter_kit: this.state.starter_kit,
					uniform: this.state.uniform,
					activity_fee: this.state.activity_fee,
					actual_fee: this.state.actual_fee,
					total_fee: this.state.total_fee,
					transport_term_1: this.state.transport_term_1,
					transport_term_1_date: this.state.transport_term_1_date,
					transport_term_2: this.state.transport_term_2,
					transport_term_2_date: this.state.transport_term_2_date,
					deposit: this.state.deposit,
					january: this.state.january,
					january_due_date: this.state.january_due_date,
					february: this.state.february,
					february_due_date: this.state.february_due_date,
					march: this.state.march,
					march_due_date: this.state.march_due_date,
					april: this.state.april,
					april_due_date: this.state.april_due_date,
					may: this.state.may,
					may_due_date: this.state.may_due_date,
					june: this.state.june,
					june_due_date: this.state.june_due_date,
					july: this.state.july,
					july_due_date: this.state.july_due_date,
					august: this.state.august,
					august_due_date: this.state.august_due_date,
					september: this.state.september,
					september_due_date: this.state.september_due_date,
					october: this.state.october,
					october_due_date: this.state.october_due_date,
					november: this.state.november,
					november_due_date: this.state.november_due_date,
					december: this.state.december,
					december_due_date: this.state.december_due_date,
					division: this.state.division,
					academic_year: this.state.academic_year,
					house: this.state.house,
					address: this.state.address,
					state: this.state.state,
					city: this.state.city,
					pincode: this.state.pincode,
					language: this.state.language,
					emergency: this.state.emergency,
					note: this.state.note,
					transport_way: this.state.transport_way,
					transport_term_3: this.state.transport_term_3,
					transport_term_3_date: this.state.transport_term_3_date,
					transport_term_4: this.state.transport_term_4,
					transport_term_4_date: this.state.transport_term_4_date,
					transport_note: this.state.transport_note,
					daycare_hour: this.state.daycare_hour,
					day_care_note: this.state.day_care_note,
					daycare_total_fee: this.state.daycare_total_fee,
					summer_camp: this.state.summer_camp,
					summer_camp_date: this.state.summer_camp_date,
					initial_fee: this.state.initial_fee,
					admission_fee_remark: this.state.admission_fee_remark,
					confirmation_fee_remark: this.state.confirmation_fee_remark,
					tuition_fee_1_remark: this.state.tuition_fee_1_remark,
					tuition_fee_2_remark: this.state.tuition_fee_2_remark,
					tuition_fee_3_remark: this.state.tuition_fee_3_remark,
					starter_kit_remark: this.state.starter_kit_remark,
					student_type: this.state.student_type,
					curriculum: this.state.curriculum,
					term: this.state.term,
					term_type: this.state.term_type,
		}
      getData('erp/edit_student_fees',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error(result.message,2);
			this.setState({ loading: false });
          }
          if(result.status==200){
			message.config({ top: 150});
			message.config({ top: 150});
			message.success('Children Fees Updated',2);
			this.setState({ loading: false });
			this.setState({comment_text:''});
			this.props.history.goBack();
			//window.location.href = '/children-profiles';
          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }

    handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

		this.setState({
		  previewImage: file.url || file.preview,
		  previewVisible: true,
		  previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
		});
	};
	
	handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        }),
      );
    }
  };
  
   handleFileSelect = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFiles.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'image',
							selectedFiles: f
						}
						storedFiles.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list:storedFiles});
		}, 500);
	} 

	removeFile= (file,e) =>{
		for (var i = 0; i < storedFiles.length; i++) {
			if (storedFiles[i].file_name === file) {
				storedFiles.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFiles.length=='0') {
				const file = document.querySelector('.file');
				//file.value = '';
			}			
			this.setState({file_list:storedFiles});
			//console.log(storedFiles);
		}, 500);
	}
	
	removeServer = (id) => {
		var app = {user_id : this.state.user_id,id:id,type:'student'}
			getData('erp/delete_student_pic',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){						
						message.config({ top: 150});
						setTimeout(() => {
							this.checkData();
						}, 500);		
				   }
				   else{
						message.config({ top: 150});
						message.error('Error while deleted image!',2);				   
				   }
				}
			});
		};



  handleChange = ({ fileList }) => this.setState({ fileList });
  
  change_status(event){
         this.setState({is_active: event});
		
     }
	 
  EmailChange = (i,e) => {
		 var id = 'prnt_email_'+i;
		 var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		 if (pattern.test(e.target.value)) {
			document.getElementById(id).innerHTML = "";
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
			document.getElementById("submit_btn").disabled = false;
		  }else{
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById(id).innerHTML = "Please Enter Valid Email !!!";
			document.getElementById("submit_btn").disabled = true;
		  }
	  
	  };
	  
	 PhoneChange = (i,e) => {
		var id = 'prnt_mobile_'+i;
		 var pattern = new RegExp(/^[0-9\b]+$/);
		 if (!pattern.test(e.target.value)) {
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById(id).innerHTML = "Please Enter Only Number !!!";
			document.getElementById("submit_btn").disabled = true;
		  }else if(e.target.value.length != 10){
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById(id).innerHTML = "Please Enter Valid Phone Number. !!!";
			document.getElementById("submit_btn").disabled = true;
		  }else{
			document.getElementById(id).innerHTML = "";
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
			document.getElementById("submit_btn").disabled = false;
			
		  }
	  };

	change_type(event){
        this.setState({student_type: event});
    }  
	  	
    change_year(event){
	    this.setState({academic_year: event});
	}
	
	
	
  createUI(){
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <img src={person} class="profile-img" />
        <img src={camera} class="profile-img-cam parent-cam" />
      </div>
    );	
	const lenght_1 = this.state.parents.length - 1;
	const lenght = this.state.parents.length;
     return this.state.parents.map((el, i) => 
		
         <div class={`col m12 mt-10 mb-10 no-padd ${i}`} key={i}>
										<div class="bb d-inline-block border pt-10 w-100 form-group p-15px">
										
						  <div class="row">
						  <div class="col-md-12">
						  <div class="row">
								<input type="hidden" value={this.state.parents[i].id} name={`parent_id_${i}`}  id={`parent_id_${i}`} />
								<div class="col-md-6 mb-20">
									<label>First Name</label>
									<input type="text" class="form-control" value={this.state.parents[i].first_name} name={`parent_first_name_${i}`}  id={`parent_first_name_${i}`} required/>
								</div>	
								<div class="col-md-6 mb-20">
									<label>Last Name</label>
									<input type="text" class="form-control" value={this.state.parents[i].last_name} name={`parent_last_name_${i}`} id={`parent_last_name_${i}`}  required/>
								</div>	
								<div class="col-md-4 mb-20">
									<label>Mobile</label>
									<input type="text" class="form-control" value={this.state.parents[i].mobile} name={`parent_mobile_${i}`} id={`parent_mobile_${i}`} onChange={this.PhoneChange.bind(this,i)} required/>
									<span class="error" id={`prnt_mobile_${i}`} ></span>
								</div>	
								<div class="col-md-4 mb-20">
									<label>Relation </label> 
									<select className="form-control old-ddl" name={`parent_relation_${i}`} id={`parent_relation_${i}`}  value={this.state.values[i].relation} required>
										<option value="">Select Relation</option>
										<option value="Mother">Mother</option>
										<option value="Father">Father</option>
										<option value="Guardian">Guardian</option>
									</select>
									
									
								</div>	
								<div class="col-md-4 mb-20">
									<label>Email</label>
									<input type="text" class="form-control"  name={`parent_email_${i}`} value={this.state.parents[i].email} id={`parent_email_${i}`} onChange={this.EmailChange.bind(this,i)}  required/>
									<span class="error" id={`prnt_email_${i}`} ></span>
								</div>	
								
						  </div>
						  </div>
						   {(() => {
							  
								if (lenght_1 == i) {
								return (
										<>
						  {(() => {
							  
								if (lenght > 1) {
								return (
									<div class="d-content">
									  <div class="col-md-12 text-center mb-10 pb-10">
											<Popconfirm
													title="Are you sure delete?"
													onConfirm={this.removeClick.bind(this,i,this.state.parents[i].id)}
													okText="Yes"
													cancelText="No"
												  >
													<Button className="btn btn-primary new-btn">Remove</Button>
										   </Popconfirm>
										</div>
									</div>
									)
								}
							})()}
							</>
							)
								}
							})()}
						</div>	
						</div>	
									
         </div>          
     )
  }
  
  addClick(){
	var myArray = {id: 0, first_name: '', last_name: '',email:'',relation:'',mobile:''};
    this.setState(prevState => ({ parents: [...prevState.parents, myArray]}))
  }
  
  goBack(){
		window.location.href = '/children-profiles/index';
	}
	
  removeClick(i,admin_id){
	 var app = {
				admin_id: admin_id ,
				user_id: this.state.user_id ,
			}
      getData('erp/school_perent_delete',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error('Not Deleted !!',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Deleted Successfully !!',2);
              this.setState({ loading: false });
              let parents = [...this.state.parents];
			  parents.splice(i,1);
			  this.setState({ parents });

          }
      });
  }
  
  
  onGetPlaceList = (e) => {
		var app = {search : e.target.value}
		getData('auth/place_search',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						place_search: result['data'],
					});
				}else{
					this.setState({
						place_search: [],
					});
				}
			}
		});
	}
	
	onSetPlace = (title,lat,lng) => {
		const $ = window.$;
		document.getElementById('search_latitude').value = lat;
		document.getElementById('search_longitude').value = lng;
		document.getElementById('search_addr').value = title;
		document.getElementById('search_location').value = title;
		this.setState({place_search:[]});
	}
	
	change_program_id(event){
	
         this.setState({program_id: event});
		 if(event == '82'){
			this.setState({program_name: 'Day Care',day_care: 1});
		 }
		 if(event == '74'){
			this.setState({program_name: 'Nursery'});
		 }
		 if(event == '73'){
			this.setState({program_name: 'Play Group'});
		 }
		 if(event == '77'){
			this.setState({program_name: 'Grade 1'});
		 }
		 if(event == '76'){
			this.setState({program_name: 'Sr. KG'});
		 }
		 if(event == '79'){
			this.setState({program_name: 'Grade 3'});
		 }
		 if(event == '78'){
			this.setState({program_name: 'Grade 2'});
		 }
		 if(event == '81'){
			this.setState({program_name: 'Grade 5'});
		 }
		 if(event == '80'){
			this.setState({program_name: 'Grade 4'});
		 }
		 if(event == '46'){
			this.setState({program_name: 'Jr. KG'});
		 }
		 
		 var app = {user_id : this.state.user_id,program_id:event,school_id:this.state.school_id}
		getData('erp/get_fees_by_school',app).then((result) => {
			let responseJson = result;
			if(responseJson){
				if(result['status'] == 200){						
						this.setState({
							actual_fee: result['data'][0]['actual_fee'],
							admission_total: result['data'][0]['admission_total'],
							other_total: result['data'][0]['other_total'],
							tuition_total: result['data'][0]['tuition_total'],
						});
						this.setState({program_name: result['data'][0]['pro_name']});		
			   }
			}
		});
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
					});
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});	
		
     }
	 
	 tutionfee4Change(date, dateString) {
	  this.setState({ tuition_fee_4_date: dateString });
	}
	 
	 tutionfee1Change(date, dateString) {
	  this.setState({ tuition_fee_1_date: dateString });
	}
	
	tutionfee2Change(date, dateString) {
	  this.setState({ tuition_fee_2_date: dateString });
	}
	
	tutionfee3Change(date, dateString) {
	  this.setState({ tuition_fee_3_date: dateString });
	}
	
	transport1Change(date, dateString) {
	  this.setState({ transport_term_1_date: dateString });
	}
	
	transport2Change(date, dateString) {
	  this.setState({ transport_term_2_date: dateString });
	}
	
	januaryDateChange(date, dateString) {
	  this.setState({ january_due_date: dateString });
	}
	
	febDateChange(date, dateString) {
	  this.setState({ february_due_date: dateString });
	}
	
	marDateChange(date, dateString) {
	  this.setState({ march_due_date: dateString });
	}
	
	aprilDateChange(date, dateString) {
	  this.setState({ april_due_date: dateString });
	}
	
	mayDateChange(date, dateString) {
	  this.setState({ may_due_date: dateString });
	}
	
	juneDateChange(date, dateString) {
	  this.setState({ june_due_date: dateString });
	}
	
	julyDateChange(date, dateString) {
	  this.setState({ july_due_date: dateString });
	}
	
	augDateChange(date, dateString) {
	  this.setState({ august_due_date: dateString });
	}
	
	sepDateChange(date, dateString) {
	  this.setState({ september_due_date: dateString });
	}
	
	octDateChange(date, dateString) {
	  this.setState({ october_due_date: dateString });
	}
	
	novDateChange(date, dateString) {
	  this.setState({ november_due_date: dateString });
	}
	
	decDateChange(date, dateString) {
	  this.setState({ december_due_date: dateString });
	}
	
	handlesms = e => {
		if(e.target.value == 0){
			this.setState({ day_care : 1 });
		}else{
			this.setState({ day_care : 0 });
		}
	};
	
	handletran = e => {
		if(e.target.value == 0){
			this.setState({ transport : 1 });
		}else{
			this.setState({ transport : 0 });
		}
	};
	
	handleCancel   = () => {
		this.setState({ fees_modal: false,modal_title:'',modal_value:'' });
	};
	
	RequestFess = (request,value) => {
		this.setState({ fees_modal : true,modal_title:request,modal_value:value });
	};
	
	SubmitRequestFess = () => {
		if(this.state.request_reason!='' && this.state.new_amount!=''){	
			var app = {user_id : this.state.user_id,school_id : this.state.school_id,child_id:this.props.match.params.id,request_for:this.state.modal_title,reason:this.state.request_reason,amount:this.state.new_amount,value:this.state.modal_value}
			getData('erp/fees_request',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){						
						message.config({ top: 150});
						message.success('Request Send For Approval !!',2);	
						this.setState({ fees_modal : false,modal_title:'',request_reason:'',new_amount:'',modal_value:'' });						
						setTimeout(() => {
							this.checkData();
						}, 500);		
				   }
				   else{
						message.config({ top: 150});
						message.error('Error!',2);				   
				   }
				}
			});
		}else{
			message.config({ top: 150});
			message.error('Please Enter Reason!',2);		
		}
	}
	
	change_fees_student(event){
		this.setState({student_type: event});
		setTimeout(() => {
			this.change_new_fees();
		}, 500);
    }  
	change_term(event){
		this.setState({term: event});
		setTimeout(() => {
			this.change_new_fees();
		}, 500);
    } 
	change_term_type(event){
		this.setState({term_type: event});
		setTimeout(() => {
			this.change_new_fees();
		}, 500);
    }
	change_curriculum(event){
		this.setState({curriculum: event});
		setTimeout(() => {
			this.change_new_fees();
		}, 500);
		
    }  
	
	change_new_fees(){
		var app = {user_id : this.state.user_id,program_id:this.state.program_id,school_id:this.state.school_id,curriculum:this.state.curriculum,term_type:this.state.term_type,term:this.state.term,academic_year:this.state.academic_year,student_type:this.state.student_type}
		getData('erp/get_fees_by_school',app).then((result) => {
			let responseJson = result;
			if(responseJson){
				if(result['status'] == 200){	
						setTimeout(() => {
						this.setState({
							actual_fee: result['data'][0]['actual_fee'],
							admission_total: result['data'][0]['admission_total'],
							other_total: result['data'][0]['other_total'],
							tuition_total: result['data'][0]['tuition_total'],
							admission_fee: result['data'][0]['admission_fee'],
							admission_form: result['data'][0]['admission_form'],
							starter_kit: result['data'][0]['starter_kit'],
							uniform: result['data'][0]['uniform'],
							activity_fee: result['data'][0]['activity_fee'],
							confirmation_fee: result['data'][0]['confirmation_fee'],
							tuition_fee_1: result['data'][0]['tuition_fee_1'],
							tuition_fee_2: result['data'][0]['tuition_fee_2'],
							tuition_fee_3: result['data'][0]['tuition_fee_3'],
							total_fee: result['data'][0]['total_fee'],
							tuition_fee_1_date: result['data'][0]['tuition_fee_1_date'],
							tuition_fee_2_date: result['data'][0]['tuition_fee_2_date'],
							tuition_fee_3_date: result['data'][0]['tuition_fee_3_date'],
							tuition_fee_4_date: result['data'][0]['tuition_fee_4_date'],
						});	
						}, 500);
			   }
			}
		});
	}
	
	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <img src={person} class="profile-img" />
        <img src={camera} class="profile-img-cam" />
      </div>
    );	
					
		return (
		<>
			
			<div class="mobile_view">
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i> Assign Children Fees - {this.state.first_name} {this.state.last_name}
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/children-profiles`} class="router-link-active" target="_self">Child Profile </a></li>
										<li class="breadcrumb-item">  Assign Children Fees</li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div id="main" class="bg-off">
         <div class="row">
	
			  {this.state.student_list.map((list) => (
			<div class="col-md-12 ex-padd">
            
            <div class="view-Profile child-profile view-Profile-mobile">
			   <div class="col-md-12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					{(() => {
					if (this.state.user_type == 'admin') {
					return (
					<>
					
					<div class="row">
					<div class="col-md-3 mb-20">	
								<label>Select Student Type *</label>	
								<Select onChange={this.change_fees_student.bind(this)} value={this.state.student_type}>
										<Select.Option value="" disabled>Select Type</Select.Option>
										<Select.Option value="new" >New</Select.Option>
										<Select.Option value="old">Old</Select.Option>
								</Select>
								</div>
								<div class="col-md-3 mb-20">	
								<label>Select Curriculum *</label>	
								<Select onChange={this.change_curriculum.bind(this)} value={this.state.curriculum} >
										<Select.Option value="" disabled>Select Curriculum</Select.Option>
										<Select.Option value="CBSE" >CBSE</Select.Option>
										<Select.Option value="Cambridge">Cambridge</Select.Option>
								</Select>
								</div>
								<div class="col-md-3 mb-20">	
								<label>Select Term *</label>	
								<Select onChange={this.change_term.bind(this)} value={this.state.term} >
										<Select.Option value="" disabled>Select Term</Select.Option>
										<Select.Option value="full" >Full Term</Select.Option>
										<Select.Option value="mid">Mid Term</Select.Option>
										<Select.Option value="mid-oct">Mid Term - Oct</Select.Option>
										<Select.Option value="mid-nov">Mid Term - Nov</Select.Option>
										<Select.Option value="mid-dec">Mid Term - Dec</Select.Option>
										<Select.Option value="mid-jan">Mid Term - Jan</Select.Option>
										<Select.Option value="mid-feb">Mid Term - Feb</Select.Option>
										<Select.Option value="mid-mar">Mid Term - Mar</Select.Option>
								</Select>
								</div>
								<div class="col-md-3 mb-20">	
								<label>Select Term Type*</label>	
								<Select onChange={this.change_term_type.bind(this)} value={this.state.term_type} >
										<Select.Option value="normal" >Normal</Select.Option>
										<Select.Option value="sibling">Sibling</Select.Option>
										<Select.Option value="one-time">One Time Payment</Select.Option>
										<Select.Option value="one-time-sibling">One Time & Sibling</Select.Option>
										<Select.Option value="staff-discount">Staff Discount</Select.Option>
								</Select>
								</div>
								</div>
					</>			
					)
					}
					})()}
								
					
					{(() => {
					if ((this.state.permission.find(element => element == 24)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
					return (
					<>
					
					<div class="children bg-blue  bg-color-6 communication mb-20 iq-card2 form-group fees-package-mod">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header={`${this.state.program_name} Fees Package (Minimum Assigned Admission Fee: Rs.${this.state.admission_total}/- , Other Fee : Rs.${this.state.other_total}/- , Tuition Fee : Rs.${this.state.tuition_total}/-  )`} key="1">
						  <div class="form-group">
						     <div class="row">
							
						     <div class="col-md-12 mb-20">
								<table>
									<thead>
										<tr>
											<th>Fee Type</th>
											<th>Fee Amount</th>
											<th>Due Date</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
									{/*
										<tr>
											<td>Initial Fee</td>
											<td><input type="number" class="form-control" value={this.state.initial_fee} name="initial_fee" onChange={this.handleSizeChange} /></td>
											<td>At time of Admission</td>
											<td>
											
											</td>
										</tr>
										
									*/}	
										<tr>
											<td>Admission Fee</td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 65)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" value={this.state.admission_fee} name="admission_fee" onChange={this.handleSizeChange} />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" value={this.state.admission_fee} name="admission_fee" onChange={this.handleSizeChange} disabled />
													</>
												)
												}
											})()}
											
											
											</td>
											<td>At time of Admission</td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 65)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														{(this.state.user_type == 'staff') ? (<>
															<input type="text" class="form-control" placeholder="Add Remark" name="admission_fee_remark" onChange={this.handleSizeChange} />
														</>):(<></>)}
													</>
												)
												}else{
												return (
													<>
														 
															{list.admission_req == '0' ? (<>
															
															<Button className="btn btn-primary mr-2 mb-0" onClick={this.RequestFess.bind(this,'Admission Fee','admission_fee')}>Edit Request</Button>
															</>):(<>
															<span class="error" >Request Submited Waiting For Approval</span>
															</>)}
														
													</>
												)
												}
											})()}
											</td>
										</tr>
										<tr>
											<td>Admission Form</td>
											<td>
											{(() => {
												if (this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" name="admission_form" value={this.state.admission_form} onChange={this.handleSizeChange}  />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" name="admission_form" value={this.state.admission_form} onChange={this.handleSizeChange} disabled  />
													</>
												)
												}
											})()}
											
											
											</td>
											<td>At time of Admission</td>
											<td></td>
										</tr>
										<tr>
											<td>Caution deposit </td>
											<td>
											{(() => {
												if ((this.state.user_type == 'admin' || this.state.user_type == 'school' ) && this.state.is_promote == 0) {
													return (
													<>
														<input type="number" class="form-control" name="cau_deposit" onChange={this.handleSizeChange} value={this.state.cau_deposit}  />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" name="cau_deposit" onChange={this.handleSizeChange} value={this.state.cau_deposit}   disabled />
													</>
												)
												}
											})()}
											
											
											</td>
											<td>{this.state.is_promote == 1 ? ('Carry Forward'):('At time of Admission')}</td>
											<td></td>
										</tr>
										<tr>
											<td>Starter Kit/Books </td>
											<td>
											
											
											
											{(() => {
												if ((this.state.permission.find(element => element == 71)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" value={this.state.starter_kit} name="starter_kit" onChange={this.handleSizeChange} />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" value={this.state.starter_kit} name="starter_kit" onChange={this.handleSizeChange}  disabled />
													</>
												)
												}
											})()}
											
											</td>
											<td>At time of Distribution</td>
											<td></td>
										</tr>
										<tr>
											<td>Uniform</td>
											<td>
											{(() => {
												if (this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" name="uniform" value={this.state.uniform} onChange={this.handleSizeChange}  />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" name="uniform" value={this.state.uniform} onChange={this.handleSizeChange}  disabled />
													</>
												)
												}
											})()}
											
											</td>
											<td>At time of Distribution</td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 67)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														{(this.state.user_type == 'staff') ? (<>
															<input type="text" class="form-control" placeholder="Add Remark" name="tuition_fee_1_remark" onChange={this.handleSizeChange} />
														</>):(<></>)}
													</>
												)
												}else{
												return (
													<>
														{list.uniform_req == '0' ? (<>
														<Button className="btn btn-primary mr-2 mb-0" onClick={this.RequestFess.bind(this,'Uniform','uniform')}>Edit Request</Button>
														</>):(<>
														<span class="error" >Request Submited Waiting For Approval</span>
														</>)}
													</>
												)
												}
											})()}
											</td>
										</tr>
										<tr>
											<td>Activity Fee</td>
											<td>
											{(() => {
												if (this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" name="activity_fee" value={this.state.activity_fee}  onChange={this.handleSizeChange}  />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" name="activity_fee" value={this.state.activity_fee}  onChange={this.handleSizeChange}  disabled />
													</>
												)
												}
											})()}
											
											
											</td>
											<td>At time of Distribution</td>
											<td></td>
										</tr>
										<tr>
											<td>Tuition Fee 1</td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 66)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" value={this.state.confirmation_fee} name="confirmation_fee" onChange={this.handleSizeChange}  />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" value={this.state.confirmation_fee} name="confirmation_fee" onChange={this.handleSizeChange}  disabled />
													</>
												)
												}
											})()}
											
											
											</td>
											<td>
											{list.tuition_fee_4_date !='' ? (
											<DatePicker  onChange={this.tutionfee4Change} defaultValue={moment(list.tuition_fee_4_date, dateFormat)}/>
											):(
											<DatePicker  onChange={this.tutionfee4Change} />
											)}
											</td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 66)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														{(this.state.user_type == 'staff') ? (<>
															<input type="text" class="form-control" placeholder="Add Remark" name="confirmation_fee_remark" onChange={this.handleSizeChange} />
														</>):(<></>)}
													</>
												)
												}else{
												return (
													<>
														{list.tuition_1_req == '0' ? (<>
															<Button className="btn btn-primary mr-2 mb-0" onClick={this.RequestFess.bind(this,'Tuition Fee 1','confirmation_fee')}>Edit Request</Button>
															</>):(<>
															<span class="error" >Request Submited Waiting For Approval</span>
															</>)}
													</>
												)
												}
											})()}
											</td>
										</tr>
										<tr>
											<td>Tuition Fee 2 </td>
											<td>
											
											{(() => {
												if ((this.state.permission.find(element => element == 67)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" value={this.state.tuition_fee_1} name="tuition_fee_1" onChange={this.handleSizeChange}  />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" value={this.state.tuition_fee_1} name="tuition_fee_1" onChange={this.handleSizeChange}  disabled />
													</>
												)
												}
											})()}
											
											
											
											</td>
											<td>
											{list.tuition_fee_1_date !='' ? (
											<DatePicker  onChange={this.tutionfee1Change} defaultValue={moment(list.tuition_fee_1_date, dateFormat)}/>
											):(
											<DatePicker  onChange={this.tutionfee1Change} />
											)}
											</td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 67)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														{(this.state.user_type == 'staff') ? (<>
															<input type="text" class="form-control" placeholder="Add Remark" name="tuition_fee_1_remark" onChange={this.handleSizeChange} />
														</>):(<></>)}
													</>
												)
												}else{
												return (
													<>
														{list.tuition_2_req == '0' ? (<>
														<Button className="btn btn-primary mr-2 mb-0" onClick={this.RequestFess.bind(this,'Tuition Fee 2','tuition_fee_1')}>Edit Request</Button>
														</>):(<>
														<span class="error" >Request Submited Waiting For Approval</span>
														</>)}
													</>
												)
												}
											})()}
											
											</td>
										</tr>
										<tr>
											<td>Tuition Fee 3 </td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 68)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" value={this.state.tuition_fee_2} name="tuition_fee_2" onChange={this.handleSizeChange}   />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" value={this.state.tuition_fee_2} name="tuition_fee_2" onChange={this.handleSizeChange}  disabled />
													</>
												)
												}
											})()}
											
											
											</td>
											<td>
											{list.tuition_fee_2_date !='' ? (
											<DatePicker onChange={this.tutionfee2Change} defaultValue={moment(list.tuition_fee_2_date, dateFormat)}/>
											):(
											<DatePicker onChange={this.tutionfee2Change} />
											)}
											</td>
											<td>
											
											{(() => {
												if ((this.state.permission.find(element => element == 68)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														{(this.state.user_type == 'staff') ? (<>
															<input type="text" class="form-control" placeholder="Add Remark" name="tuition_fee_2_remark" onChange={this.handleSizeChange} />
														</>):(<></>)}
													</>
												)
												}else{
												return (
													<>
														{list.tuition_3_req == '0' ? (<>
														<Button className="btn btn-primary mr-2 mb-0" onClick={this.RequestFess.bind(this,'Tuition Fee 3','tuition_fee_2')}>Edit Request</Button>
														</>):(<>
														<span class="error" >Request Submited Waiting For Approval</span>
														</>)}
													</>
												)
												}
											})()}
											
											</td>
										</tr>
										<tr>
											<td>Tuition Fee 4</td>
											<td>
											{(() => {
												if ((this.state.permission.find(element => element == 69)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														<input type="number" class="form-control" value={this.state.tuition_fee_3} name="tuition_fee_3" onChange={this.handleSizeChange}   />
													</>
												)
												}else{
												return (
													<>
														<input type="number" class="form-control" value={this.state.tuition_fee_3} name="tuition_fee_3" onChange={this.handleSizeChange}  disabled />
													</>
												)
												}
											})()}
											
											
											</td>
											<td>
											{list.tuition_fee_3_date !='' ? (
											<DatePicker onChange={this.tutionfee3Change} defaultValue={moment(list.tuition_fee_3_date, dateFormat)}/>
											):(
											<DatePicker onChange={this.tutionfee3Change} />
											)}
											</td>
											<td>
											
											{(() => {
												if ((this.state.permission.find(element => element == 69)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
													return (
													<>
														{(this.state.user_type == 'staff') ? (<>
															<input type="text" class="form-control" placeholder="Add Remark" name="tuition_fee_3_remark" onChange={this.handleSizeChange} />
														</>):(<></>)}
													</>
												)
												}else{
												return (
													<>
														{list.tuition_4_req == '0' ? (<>
														<Button className="btn btn-primary mr-2 mb-0" onClick={this.RequestFess.bind(this,'Tuition Fee 4','tuition_fee_3')}>Edit Request</Button>
														</>):(<>
														<span class="error" >Request Submited Waiting For Approval</span>
														</>)}
													</>
												)
												}
											})()}
											
											</td>
										</tr>
										
										<tr>
											<td>Notes </td>
											<td colspan="2"><input type="text" class="form-control" name="note" onChange={this.handleSizeChange} value={this.state.note} /></td>
										</tr>
										<tr>
											<td class="total-amount">Total </td>
											<td class="total-amount"><span name="total_fee">Rs. {this.state.total_fee}</span></td>
											<td></td>
										</tr>
									</tbody>
								</table>
							  </div>
							  
							  
							  </div>
						   </div>
						</Panel>
					  </Collapse>
					</div>
					</>
					)
					}
					})()}
					
					
					
					<div class="children bg-blue  bg-color-6 communication mb-20 iq-card2 form-group fees-package-mod">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header={`Summer Camp Fees Package`} key="1">
						  <div class="form-group">
						     <div class="row">
							 
						     <div class="col-md-12 mb-20">
								<table>
									<thead>
										<tr>
											<th>Fee Amount</th>
											<th>Due Date</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><input type="number" class="form-control" name="summer_camp" value={this.state.summer_camp} onChange={this.handleSizeChange}  /></td>
											<td>
													{list.summer_camp_date !='' ? (
													<DatePicker defaultValue={moment(list.summer_camp_date, dateFormat)} onChange={this.summercampChange} />
													):(
													<DatePicker onChange={this.summercampChange} />
													)}</td>
										</tr>
									</tbody>
								</table>
							  </div>
							  
							  
							  </div>
						   </div>
						</Panel>
					  </Collapse>
					</div>		

					<Modal className="pay-fees-modal" title={`Request For : ${this.state.modal_title}`} visible={this.state.fees_modal} onOk={this.SubmitRequestFess.bind(this)} onCancel={this.handleCancel.bind(this)} >
						<div class="row">
						
						<div class="col-md-12 mt-20 ">
						<div class="form-group">
							<label>Fees Amount*</label>
							<input type="number" class="form-control" pattern="[0-9]*" name="new_amount" onChange={this.handleSizeChange} value={this.state.new_amount} />
							
						</div>
						</div>
						<div class="col-md-12">
						<div class="form-group">
							<label>Reason*</label>
							<TextArea
								  placeholder="Enter Reason Here !!"
								  autoSize={{ minRows: 2, maxRows: 6 }}
								  onChange={this.handleSizeChange}
								  value={this.state.request_reason}
								  name="request_reason"
								  id="request_reason"
								/>
							
						</div>
						</div>
						<div class="col-md-12">
						<div class="form-group center">
							<Button className="btn btn-primary mr-2" onClick={this.SubmitRequestFess.bind(this)} loading={this.state.loading}>Submit</Button>
						</div>
						</div>
						</div>
					</Modal>	

						
					<div class="  bb pb-20 ">
					</div>
					
					<div class="col-md-12 meal mt-4 mb-20  text-center">
						 <Button className="btn btn-primary mr-2" id="submit_btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
						 
						 <Button className="btn btn-primary new-btn mr-2"  onClick={this.context.router.history.goBack}>Back</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			))}
         </div>
      </div>
     
			</div>
		</>	
		) 
	} 
}
export default Index;
